import { normalizeWebviewPreviewUrl } from '@/lib/api-origin';
import {
	WEBVIEW_TEMPLATE_IDS,
	WEBVIEW_TEMPLATES,
	webviewTemplatePath,
	type WebviewTemplateId,
} from '@crave/config/webview-templates';

export { WEBVIEW_TEMPLATE_IDS, WEBVIEW_TEMPLATES, type WebviewTemplateId };

export function resolveWebviewPreviewUrl(
	webviewType: WebviewTemplateId | null,
	customUrl: string | null,
	apiOrigin: string,
): string | null {
	if (!webviewType) {
		return null;
	}

	if (webviewType === 'custom') {
		return customUrl ? normalizeWebviewPreviewUrl(customUrl) : null;
	}

	const template = WEBVIEW_TEMPLATES[webviewType];
	if (!template.available || !template.slug) {
		return null;
	}

	return `${apiOrigin}${webviewTemplatePath(template.slug)}`;
}
